import { render } from "./About.vue?vue&type=template&id=8ccf8cd0&scoped=true&bindings={}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=8ccf8cd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8ccf8cd0"

export default script